// import { domains } from 'config/env'
import { domains } from '../../../lib/config'

const ACCOUNT_DETAILS = 'Account Details'
const HELP = 'Help'
const LOG_OUT = 'Log out'
const MY_DASHBOARD = 'My Dashboard'

export const NAVIGATION_ITEMS = [
  {
    label: MY_DASHBOARD,
    link: domains.CURRICULUM_APP_DOMAIN,
  },
  {
    label: ACCOUNT_DETAILS,
    link: `${domains.APP_DOMAIN}/account-details`,
  },
  {
    label: HELP,
    link: 'https://support.secondstep.org/',
  },
  {
    label: LOG_OUT,
    link: '/signout',
  },
]
